<script setup>
import { computed } from 'vue'
import { DropdownMenuItem, useForwardPropsEmits } from 'radix-vue'

/* eslint-disable vue/require-default-prop */
const props = defineProps({
  disabled: { type: Boolean, required: false },
  textValue: { type: String, required: false },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: { type: null, required: false },
})

const emits = defineEmits(['select'])

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
  <li>
    <DropdownMenuItem
      v-bind="forwarded"
      role="button"
      :class="['dropdown-item', props.class, props.disabled && 'disabled']"
    >
      <slot />
    </DropdownMenuItem>
  </li>
</template>
